import React from "react";

function Tokens() {
  return (
    <div className="tokens-container">
      <h1 className="tokens-title">🚧 Tokens Page</h1>
      <p className="tokens-subtitle">This section is currently under construction.</p>
      <div className="coming-soon">Coming Soon</div>
    </div>
  );
}

export default Tokens;

